// Do not reorder, the frontend uses the order to display categories
export enum CategoryType {
	Coffee = "Coffee",
	Accessory = "Accessory",
	Merch = "Merch",
}
